export default __webpack_public_path__ + "resources/icons/d430-af16.png";